/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Legal entity type.
 */
export type LegalEntityType = (typeof LegalEntityType)[keyof typeof LegalEntityType];

export const LegalEntityType = {
  individual: "individual",
  company: "company",
} as const;
